import { fetchServiceMetadata } from "@/services/assets/services"
import type { IWebCOOSParsedGalleryService } from "@/services/assets/types"
import ApiContext from "@/state/ApiContext"
import { useQuery, type UseQueryResult } from "@tanstack/react-query"
import { useContext } from "react"

export type WebCOOSAssetProps = {
    token: string
    apiUrl: string
}

export const useWebCOOSServiceMetadata = (serviceIdentifier: string): UseQueryResult<IWebCOOSParsedGalleryService> => {
    const apiContext = useContext(ApiContext)
    const queryResult = useQuery({
        queryKey: ['service', 'metadata', serviceIdentifier],
        queryFn: async ({ signal }): Promise<IWebCOOSParsedGalleryService> => {
            const service = await fetchServiceMetadata({
                ...apiContext,
                signal,
                serviceIdentifier

            })
            return service
        }
    })

    return queryResult
}
